import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _AmountTypeCharacter, _amountTypes;

import { BasicColumnTypes } from '@opengov/ogql-types'; // the possible column types for amounts

export var AmountType;

(function (AmountType) {
  AmountType["Currency"] = "currency";
  AmountType["Percent"] = "percentage";
  AmountType["Numeric"] = "numeric";
})(AmountType || (AmountType = {}));

export var amountTypeValues = Object.values(AmountType);
export var AmountTypeCharacter = (_AmountTypeCharacter = {}, _defineProperty(_AmountTypeCharacter, AmountType.Numeric, '#'), _defineProperty(_AmountTypeCharacter, AmountType.Percent, '%'), _defineProperty(_AmountTypeCharacter, AmountType.Currency, '$'), _AmountTypeCharacter); // turn a number into a 3 number character string

export var digitRemover = function digitRemover(nmbr) {
  var s = nmbr.toString();
  if (s.length < 3) return s;
  var numberString = '';
  var numbersFound = 0;

  for (var i = 0; numbersFound < 3 && i < s.length; i++) {
    numberString += s[i];
    if (s[i] !== '.') numbersFound++;
  }

  if (numbersFound < 2) {
    numberString += '0';
  }

  return numberString;
};
export var abbreviateNumber = function abbreviateNumber(nmbr) {
  var absoluteValue = Math.abs(nmbr);
  if (absoluteValue <= 999) return "".concat(digitRemover(absoluteValue));
  if (absoluteValue <= 999999) return "".concat(digitRemover(absoluteValue / 1000), "k");
  if (absoluteValue <= 999999999) return "".concat(digitRemover(absoluteValue / 1000000), "M");
  if (absoluteValue <= 999999999999) return "".concat(digitRemover(absoluteValue / 1000000000), "B");
  if (absoluteValue <= 999999999999999) return "".concat(digitRemover(absoluteValue / 1000000000000), "T");
  if (absoluteValue <= 999999999999999999) return "".concat(digitRemover(absoluteValue / 1000000000000000), "Q");
};
export var calculateColumnAmountType = function calculateColumnAmountType(column) {
  if (column.type === BasicColumnTypes.Numeric) {
    if (column.semanticTypes && column.semanticTypes.find(function (t) {
      return t.type.includes(AmountType.Percent);
    })) return AmountType.Percent;
    if (column.semanticTypes && column.semanticTypes.find(function (t) {
      return t.type.includes(AmountType.Currency);
    })) return AmountType.Currency;
    return AmountType.Numeric;
  }

  if (column.type === BasicColumnTypes.DayInterval || column.type === BasicColumnTypes.YearInterval) {
    return AmountType.Numeric;
  }

  return column.type;
};

var sign = function sign(nmbr) {
  return nmbr < 0 ? "-" : "";
};

export var amountTypes = (_amountTypes = {}, _defineProperty(_amountTypes, AmountType.Currency, {
  formatter: function formatter(nmbr) {
    return "".concat(sign(nmbr)).concat(AmountTypeCharacter[AmountType.Currency]).concat(abbreviateNumber(nmbr));
  },
  size: 50
}), _defineProperty(_amountTypes, AmountType.Percent, {
  formatter: function formatter(nmbr) {
    return "".concat(sign(nmbr)).concat(abbreviateNumber(nmbr * 100)).concat(AmountTypeCharacter[AmountType.Percent]);
  },
  size: 50
}), _defineProperty(_amountTypes, AmountType.Numeric, {
  formatter: function formatter(nmbr) {
    return "".concat(sign(nmbr)).concat(abbreviateNumber(nmbr));
  },
  size: 50
}), _amountTypes);